// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { AiApiSpec_emptySchema } from './AiApiSpec_emptySchema';

export const AiApiSpec_getAssistantResponseQueryParamsSchema = z.object({
  message: z.coerce.string(),
  tic_user_id: z.coerce.string(),
  timely_account_id: z.number(),
  timely_user_id: z.number(),
  session_id: z.optional(z.coerce.string()),
});

/**
 * @description 200 response
 */
export const AiApiSpec_getAssistantResponse200Schema = z.lazy(() => AiApiSpec_emptySchema);

export const AiApiSpec_getAssistantResponseQueryResponseSchema = z.lazy(() => AiApiSpec_getAssistantResponse200Schema);
